import styled from 'styled-components'
import { TextField } from '@mui/material'
import { Link } from 'react-router-dom'

export const GiftRedeemWrapper = styled.div`
  background-color: black;
  min-height: 100vh;
  font-family: Outfit;
`

export const GiftCardRedeemContent = styled.div`
  min-height: calc(100vh - 140px);
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 16px 0;
  @media (min-width: 768px) {
    padding: 120px 16px 0;
  }
`

export const GiftCardRedeemWelcome = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  margin-bottom: 10px;
  color: #ffffff;
  @media (min-width: 768px) {
    font-size: 50px;
    line-height: 52px;
    margin-bottom: 20px;
  }
`

export const GiftCardRedeemHeader = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  text-align: center;
  margin-bottom: 8px;
  color: ${(props) => props.color};
  @media (min-width: 768px) {
    font-size: 43px;
    line-height: 52px;
    margin-bottom: 16px;
  }
`

export const GiftCardRedeemText = styled.div`
  width: 100%;
  max-width: 1072px;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 27px;
  /* identical to box height */
  letter-spacing: -0.5px;
  color: #d2d2d2;
  margin-bottom: 50px;
`
export const GiftRedeemEntry = styled.div`
  display: flex;
  margin-top: 32px;
  margin-bottom: 68px;
  @media (min-width: 768px) {
    margin-top: 62px;
    margin-bottom: 136px;
  }
`

export const GiftRedeemTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    background: #ffffff;
    box-shadow: 3px 5px 23px rgba(0, 0, 0, 0.18);
    border-radius: 67px;
    maxWidth: 500px;
    width: 100%,
    height: 92px;
    transition: width 0.6s ease, height 0.6s ease; /* Add smooth transition */
    .MuiOutlinedInput-input {
      padding: 10px 40px;
      font-weight: 400;
      font-size: 20px;
      line-height: 30px;
      color: #000000;
    }
    .MuiOutlinedInput-notchedOutline {
      border: none;
    }
  }
`

export const StyledGiftRedeemImg = styled.img`
  width: 100%;
  height: 40vh;
  object-fit: cover;
`

export const ArrowForwardIconButton = styled.div`
  .MuiSvgIcon-root {
    height: 40px;
    width: 40px;
  }
  &:hover {
    cursor: pointer;
  }
`

export const StyledSuccessButton = styled(Link)`
  background: #ffffff;
  box-shadow: 10px 8px 27px rgba(0, 0, 0, 0.91), inset 4px 4px 8px rgba(0, 0, 0, 0.33);
  border-radius: 48px;
  padding: 22px 75px;
  font-style: normal;
  font-weight: 500;
  font-size: 19px;
  line-height: 23px;
  z-index: 1000;
  color: #000000;
  text-decoration: none;
`

export const StyledSuccessButtonATag = styled.a`
  background: #ffffff;
  // box-shadow: 10px 8px 27px rgba(0, 0, 0, 0.91), inset 4px 4px 8px rgba(0, 0, 0, 0.33);
  border-radius: 48px;
  padding: 16px;
  font-style: normal;
  font-weight: 500;
  font-size: 19px;
  line-height: 23px;
  z-index: 1000;
  color: #000000;
  text-decoration: none;
  text-align: center;
  width: 100%;
  max-width: 500px;
`

export const StyledErrorButton = styled.button`
  background: #ffffff;
  box-shadow: 10px 8px 27px rgba(0, 0, 0, 0.91), inset 4px 4px 8px rgba(0, 0, 0, 0.33);
  border-radius: 48px;
  padding: 22px 75px;
  font-style: normal;
  font-weight: 500;
  font-size: 19px;
  line-height: 23px;
  z-index: 1000;
  color: #000000;
`
